import React from 'react';
export function Templates() {
  return <div data-id="element-2453">
      <div className="flex justify-between items-center mb-6" data-id="element-2454">
        <h1 className="text-2xl font-bold" data-id="element-2455">Email & Document Templates</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2456">
          Create Template
        </button>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-2457">
        <table className="min-w-full divide-y divide-neutral-200" data-id="element-2458">
          <thead className="bg-neutral-50" data-id="element-2459">
            <tr data-id="element-2460">
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2461">
                Template Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2462">
                Type
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2463">
                Last Modified
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2464">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-neutral-200" data-id="element-2465">
            <tr data-id="element-2466">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2467">
                <div className="text-sm font-medium text-neutral-900" data-id="element-2468">
                  Welcome Email
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2469">
                <div className="text-sm text-neutral-500" data-id="element-2470">Email</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2471">
                <div className="text-sm text-neutral-500" data-id="element-2472">Jan 15, 2023</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-2473">
                <button className="text-blue-600 hover:text-blue-900 mr-2" data-id="element-2474">
                  Edit
                </button>
                <button className="text-neutral-600 hover:text-neutral-900 mr-2" data-id="element-2475">
                  Preview
                </button>
                <button className="text-red-600 hover:text-red-900" data-id="element-2476">
                  Delete
                </button>
              </td>
            </tr>
            <tr data-id="element-2477">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2478">
                <div className="text-sm font-medium text-neutral-900" data-id="element-2479">
                  Policy Renewal Notice
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2480">
                <div className="text-sm text-neutral-500" data-id="element-2481">Email</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2482">
                <div className="text-sm text-neutral-500" data-id="element-2483">Dec 10, 2022</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-2484">
                <button className="text-blue-600 hover:text-blue-900 mr-2" data-id="element-2485">
                  Edit
                </button>
                <button className="text-neutral-600 hover:text-neutral-900 mr-2" data-id="element-2486">
                  Preview
                </button>
                <button className="text-red-600 hover:text-red-900" data-id="element-2487">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}